import React, { FunctionComponent } from 'react';

export type Occupation = {
  occupation: string[];
  occupationDetail: string | null;
};

type Props = {
  id: string;
  title: string;
  value: any;
  word: string;
  penIconImg: string;
  isShow: boolean;
  isPc?: boolean;
  last?: boolean;
  disabled?: boolean;
  unCompleted?: boolean;
  onClickItem: (event: React.MouseEvent<HTMLDivElement>) => void;
  isDisplay: boolean;
  isSelection: boolean;
  isOccupation: boolean;
  isSalary: boolean;
  salaryWord: (salaryRange: number) => string;
};

export const Presentation: FunctionComponent<Props> = ({
  id,
  title,
  value,
  word,
  penIconImg,
  isShow,
  isPc,
  last,
  disabled,
  unCompleted,
  onClickItem,
  isDisplay,
  isSelection,
  isOccupation,
  isSalary,
  salaryWord,
}) => {
  return (
    <>
      {isDisplay && id === 'instagram' && isPc && <hr className="person__show__sidebar--devide" />}
      {isDisplay && (
        <div
          className={`person__show__sidebar__item ${last ? 'last' : ''} ${disabled || !isShow ? 'disabled' : ''}`}
          onClick={onClickItem}
          id={id}
        >
          <div className="person__show__sidebar__item--heading">
            <p className="title">
              {id === "twitter" ? (
                <>
                  X
                  <span className="sub">{title}</span>
                </>
              ) : (
                title
              )}
            </p>
            {unCompleted && <i className="fas fa-exclamation-circle" aria-hidden="true"></i>}
            <img src={penIconImg} alt="ペンアイコン画像" className="pen" />
          </div>

          <div className="person__show__sidebar__item--content">
            {value === 'null(歳)' && id === 'birthday' && <p className="selectable">{word}</p>}

            {value !== 'null(歳)' && value !== null && value !== '' && !isOccupation && !isSalary && (
              <p className="normal">{value}</p>
            )}

            {value !== 'null(歳)' && value !== null && value !== '' && isOccupation && Array.isArray(value) && value.length > 0 && (
              value.map((obj: any, index: number) => {
                const key = obj.occupation?.[0] || obj;
                return (
                  <div className="occupations" key={`${key}_${index}`}>
                    <p>・{obj.occupation?.[0] || obj}</p>
                    {obj.occupationDetail && (
                      <>
                        <strong>：</strong>
                        <p>{obj.occupationDetail}</p>
                      </>
                    )}
                  </div>
                );
              })
            )}

            {value !== 'null(歳)' && value !== null && value !== '' && isOccupation && Array.isArray(value) && value.length === 0 && (
              <p className="selectable">{word}</p>
            )}

            {value !== 'null(歳)' && value !== null && value !== '' && isSalary && (
              <p className="normal">{salaryWord(value)}</p>
            )}

            {isSelection && <p className="selectable">{word}</p>}
          </div>
        </div>
      )}
    </>
  );
};
